import React from 'react'

import classes from './MovieCategoryOption.module.scss';
import svgCheck from '../../assets/check-circle-regular.svg';

function MovieCategoryOption(props) {
    return (
        <React.Fragment>
            <input type="radio" name="options" id={props.id} value={props.value}
                className={classes['homeform__options--radioinput']}
                onChange={props.onChange} />
            <label htmlFor={props.id} className={classes['homeform__options--radiolabel']}>
                <div className={classes['homeform__options--radiolabel--checkedoverlay']}>
                    <svg>
                        <use xlinkHref={`${svgCheck}#check`}></use>
                    </svg>
                    <span>{props.value} </span>
                </div>
                <img src={props.displayImg} alt="option boolywood" />
            </label>
        </React.Fragment>
    )
}

export default MovieCategoryOption
